export enum JobStatusEnum {
  OPEN = 'OPEN',
  ARCHIVED = 'ARCHIVED',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
  JOB_REQUESTED = 'JOB_REQUESTED',
}
